import type { QuantifiedPlan } from '../../../services/areasService';

/** Sidebar section id; also written to the URL so Back from a drilled-into task reopens this report. */
export const QUANTIFIED_VALUE_REPORT_SECTION = 'operations-quantified-value';

/** Section id used before the report moved from Finance to Operations; old bookmarks and Back history still carry it. */
export const LEGACY_QUANTIFIED_VALUE_REPORT_SECTION = 'finance-quantified-value';

/**
 * Picks the contract year whose plan window contains today. Plan years are contract years (7, 8, ...),
 * not calendar years, so the window dates are the only reliable link to "now". Falls back to the
 * latest Open plan, then the latest plan.
 */
export function pickCurrentPlanYear(
  plans: Pick<QuantifiedPlan, 'year' | 'status' | 'startDate' | 'endDate'>[],
  today: Date = new Date()
): number | null {
  const current = plans.find((p) => {
    const start = new Date(p.startDate);
    const end = new Date(p.endDate);
    return !isNaN(start.getTime()) && !isNaN(end.getTime()) && start <= today && today <= end;
  });
  if (current) return current.year;
  const openYears = plans.filter((p) => p.status === 'Open').map((p) => p.year);
  if (openYears.length > 0) return Math.max(...openYears);
  if (plans.length > 0) return Math.max(...plans.map((p) => p.year));
  return null;
}
